import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

import { color } from 'theme/selectors';

import FemaleAppBackground from './img/DownloadAppFemaleBg.webp';
import MaleAppBackground from './img/DownloadAppMaleBg.webp';

export type Variant = 'male' | 'female';

const getBackgroundImage = (variant: Variant) => {
    return variant === 'female' ? FemaleAppBackground : MaleAppBackground;
};

const headerHeight = 56;
const cookieBannerHeight = 164;

export const Container = styled(Box)<{ $variant: Variant; $isCookieBannerVisible: boolean }>`
    padding: 0 16px 32px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex: 1 0 0;
    height: calc(100vh - ${headerHeight}px);
    height: calc(100dvh - ${headerHeight}px);
    height: calc(-webkit-fill-available - ${headerHeight}px);
    overflow-wrap: break-word;
    background:
        linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 181.4%),
        url(${(props) => getBackgroundImage(props.$variant)}) center / cover no-repeat;

    ${({ $isCookieBannerVisible }) =>
        $isCookieBannerVisible && `padding-bottom: calc(${cookieBannerHeight}px + 14px);`};
`;

export const Email = styled.span`
    color: ${color('text-main')};
    font-weight: bold;
`;
